import { render } from "./MobileVersion2View.vue?vue&type=template&id=b54aedae&scoped=true"
import script from "./MobileVersion2View.vue?vue&type=script&lang=js"
export * from "./MobileVersion2View.vue?vue&type=script&lang=js"

import "./MobileVersion2View.vue?vue&type=style&index=0&id=b54aedae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b54aedae"]])

export default __exports__